import { datadogAddAction } from 'src/pages/tenant/QuestionnaireV4/utils';

/** Presigned S3 URLs sign the exact query string — never append params. */
export const isPresignedS3Url = (url: string): boolean =>
  /[?&]X-Amz-Signature=/i.test(url);

export const cacheBustPdfUrl = (url: string): string => {
  if (!url || isPresignedS3Url(url)) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${Date.now()}`;
};

export const getTimeZone = (): string => {
  let timeZone;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.error(error);
    datadogAddAction(error, 'ESign_TimeZoneError');
    timeZone = null;
  }
  return timeZone;
};
